import { jsx as _jsx } from "react/jsx-runtime";
import { styled, useStyleConfig, vui } from '../core';
import { cs } from '../utils';
import { useTableContext } from './context';
export const TrBase = styled.trBox `
  transition-duration: fast;
`;
/** Displays Table row that can contain heading or data cells. */
export const Tr = vui((props, ref) => {
    const { className, isSelected, ...rest } = props;
    const { variant } = useTableContext() ?? {};
    const styles = useStyleConfig('Table', useTableContext());
    const selectedProps = isSelected ? { bg: 'skyBlue.selected' } : {};
    return (_jsx(TrBase, { className: cs('vui-tr', className), "data-selected": Boolean(isSelected), "data-variant": variant, ref: ref, ...styles.tr, ...selectedProps, ...rest }));
});
Tr.displayName = 'Tr';
export default Tr;
